export const isLinguaproz: boolean = import.meta.env.VITE_MODE === 'linguaproz';
export const appTitle: string = isLinguaproz ? 'LínguaProz' : 'Translyx CAT';
